module.exports = __webpack_public_path__ + "static/media/1.76f840e9.jpg";